/**
 * API Configuration
 * Centralized API URL management for both local dev and production
 *
 * Local Dev:
 *   - Backend: localhost:3007
 *   - Frontend: localhost:3002
 *
 * Production/Staging:
 *   - Backend: Set via REACT_APP_API_URL env var in Vercel
 *   - Staging: https://optimus-os-private-staging.onrender.com
 *   - Production: https://optimus-os-private.onrender.com
 */

// Get API URL from environment variable or fallback to localhost/LAN for local dev
// Each Vercel project (staging/prod) sets its own REACT_APP_API_URL
const getLocalApiUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;

  // Dynamic check for LAN/WiFi access (e.g. 192.168.x.x)
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      return `http://${hostname}:3007`;
    }
  }
  return "http://localhost:3007";
};

export const API_BASE_URL = getLocalApiUrl();

// Frontend URL for affiliate links and redirects
const getFrontendUrl = () => {
  if (process.env.REACT_APP_AFFILIATE_TARGET_URL) return process.env.REACT_APP_AFFILIATE_TARGET_URL;
  if (process.env.REACT_APP_FRONTEND_URL) return process.env.REACT_APP_FRONTEND_URL;

  // Dynamic public URL based on hostname
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Production/Staging domains
    if (
      hostname.includes('osoptimus.com') ||
      hostname.includes('onrender.com') ||
      hostname.endsWith('.optimus.university')
    ) {
      return "https://activateoptimus.com"; // Default affiliate target
    }
  }
  return "http://localhost:3002";
};

// Frontend URL for affiliate links and redirects
export const FRONTEND_URL = getFrontendUrl();

// Helper function to build API endpoint URLs
export function apiUrl(path) {
  // Ensure path starts with /
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_BASE_URL}${cleanPath}`;
}

// Common fetch wrapper with proper configuration
export async function apiFetch(path, options = {}) {
  const url = apiUrl(path);

  const defaultOptions = {
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
    credentials: "include", // Important for cookies/sessions
    ...options,
  };

  try {
    const response = await fetch(url, defaultOptions);
    return response;
  } catch (error) {
    console.error("API request failed:", error);
    throw error;
  }
}

// Export for logging/debugging
console.log("🌐 API Configuration:", {
  API_BASE_URL,
  FRONTEND_URL,
  env: process.env.NODE_ENV,
});
